export const extractInitials = function(str) {
  if (!str) return str;
  const initials = str.match(/\b\w/g) || [];
  return ((initials.shift() || "") + (initials.pop() || "")).toUpperCase();
};

export default { extractInitials };
